

export const resolveErrorMessage = (error: any, defaultMessage: string) => {
  if (error.errors) {
    const messages = Object.values<string[]>(error.errors).flatMap(m => m);
    if (messages.length) return messages.join(' ');
  }
  if (error.message) {
    return error.message;
  }
  return defaultMessage;
}

